import { render } from "./Promo.vue?vue&type=template&id=3702ce7d&scoped=true"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"

import "./Promo.vue?vue&type=style&index=0&id=3702ce7d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3702ce7d"]])

export default __exports__